export {MindmapModule} from './core/mindmap.module';
export {MindmapService} from './core/mindmap.service';
export {ServicesInstantiatorService as MindmapServicesInstantiatorService} from './core/services/services-instantiator.service';